import { useEffect } from 'react';
import type React from 'react';

import { Link, SocialIcon, SocialSharingGroup as SocialIconsGroup, Text } from '@change/ds-core-ui';

import { useElectionsData } from './hooks/useElectionsData';

export const WebsitesContainer: React.FC<EmptyProps> = () => {
	const {
		data: { personalWebsite, socialLinks },
	} = useElectionsData();

	if (!personalWebsite && socialLinks.length === 0) return null;

	return <Websites />;
};

const Websites: React.FC<EmptyProps> = () => {
	const {
		data: { headingText, personalWebsite, socialLinks },
		actions: { trackView, handleTrackLinkClick },
	} = useElectionsData();

	useEffect(() => {
		trackView();
	}, [trackView]);

	return (
		<div className="flex flex-col" data-testid="dm-websites-container">
			<Text as="h2" variant="heading" size="small" className="mb-5">
				{headingText}
			</Text>

			{personalWebsite && (
				<div className="mb-5">
					<Link
						href={personalWebsite}
						target="_blank"
						rel="noopener"
						className="block overflow-hidden"
						data-qa="dm-personal-website-link"
						onClick={() =>
							handleTrackLinkClick({
								platform: 'personal_website',
								url: personalWebsite,
							})
						}
					>
						<Text size="large" className="text-typography-strong block truncate">
							{personalWebsite}
						</Text>
					</Link>
				</div>
			)}

			<SocialIconsGroup className="flex justify-start gap-2.5">
				{socialLinks.map(({ platform, url, icon: Icon, variant }) => (
					<Link
						key={`Share_${platform}`}
						href={url}
						target="_blank"
						rel="noopener"
						data-qa={`dm-social-link_${platform}`}
						onClick={() => handleTrackLinkClick({ platform, url })}
					>
						<SocialIcon
							icon={<Icon />}
							aria-label={platform}
							size="large"
							variant={variant}
							role={undefined}
							data-qa={platform}
							className="h-[44px] w-[44px]"
						/>
					</Link>
				))}
			</SocialIconsGroup>
		</div>
	);
};
